







































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { getChannelOption, setContentSeq } from '@/api/common'
import { IChannel } from '@/api/content/content-channel/res'
import { getChannelList, setAppTop, setAppDelete, dragSort, copyChannel, moveChannels, randomChannels, getChannelConfig, setChannelConfig } from '@/api/content/content-channel/channel'
import { exportJson2Excel } from '@/utils/excel'
import { formatJson, resetObjValue2NoneString, deepCopy, randomOne } from '@/utils/tool'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import Sortable from 'sortablejs'

@Component({
  name: 'ContentChannel'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    nid: '',
    appId: '',
    appName: '',
    editor: '',
    status: '',
    updateDateStart: '',
    updateDateEnd: '',
    createDateStart: '',
    createDateEnd: '',
    platform: 1,
    page: 1,
    pageCount: 20
  }
  // template data
  tableLoading = true
  private tableData: IChannel[] = []
  private selectedData: IChannel[] = []
  private selectList: any[] = [] // 级联选择
  private cascaderList: any[] = []
  private asideList: any[] = [] // 侧栏选择
  private value: number[] = [] // 级联选中项
  private copyConfig: number[] = []
  private openeds: string[] = [] // 侧栏展开项
  private dateArray1: string[] = ['', '']
  private dateArray2: string[] = ['', '']
  private totalCount: number = 0
  private num1: number = 0
  private num2: number = 0
  private num3: number = 0
  private casProps: any = {
    lazy: true,
    lazyLoad: async(node: any, resolve: Function) => {
      const { level, value } = node
      if (level !== 3) {
        resolve()
        return false
      }
      let res: any = await getChannelOption({
        type: 1,
        pos: 'left',
        pid: value
      })
      if (res && res.data) {
        let nodes: any[] = res.data || []
        nodes.forEach((item: any) => {
          if (item.children) {
            item.children.forEach((element: any) => {
              element.leaf = true
            })
          }
        })
        resolve(nodes)
      } else {
        resolve()
      }
    }
  }
  routeQuery: IQuery = { id: 0 }
  activeIndex: string = '0'
  openWindow: any
  tableHeight: number = 500
  config: string = ''
  operate: string = ''
  // lifecycle
  async created() {
    if (this.$route.query.value) {
      let { nid, value } = this.$route.query
      this.value = value.toString().split(',').map(item => +item)
      this.params.nid = nid as string
    }
    if (this.$route.query.config) {
      this.config = this.$route.query.config as string
    }
    await this.getChannelOption()
    await this.getAsideOption(this.value[2])
    await this.getTableData()
    if (this.$route.query.activeIndex) {
      this.activeIndex = this.$route.query.activeIndex as string
    }
    this.getConfig()
  }
  mounted() {
    this.rowDrop()
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }
  // methods
  async getChannelOption() {
    // TODO: 初始值
    let res = await getChannelOption({
      type: 1,
      pos: 'top',
      pid: 1
    })
    this.selectList = res.data
    this.cascaderList = deepCopy(res.data)
    // this.value = [2, 4, 10]
    if (this.value.length <= 0) {
      this.value = [2, 4, 10]
    }
  }
  getConfig() {
    getChannelConfig({ platform: this.platform }).then(({ data: { app_page: num1, game_page: num2, home_page: num3 } }: any) => {
      this.num1 = num1
      this.num2 = num2
      this.num3 = num3
    })
  }
  handleSave() {
    const { num1, num2, num3, platform } = this
    const data = { app_page: num1, game_page: num2, home_page: num3, platform }
    setChannelConfig(data).then(() => {
      this.getConfig()
    })
  }
  // TODO: 必须传一个 id 或者初始菜单
  async getAsideOption(pid = 10, refresh: boolean = false) {
    let res: any = await getChannelOption({
      type: 1,
      pos: 'left',
      pid: pid
    })
    this.asideList = res.data
    if (refresh) {
      this.params.nid = ''
    }
    let nid = this.params.nid
    if (!nid) {
      nid = res.data[0].children[0]['value']
    }
    this.params.nid = nid
    this.activeIndex = nid.toString()
    this.openeds = this.asideList.map(item => item.value.toString())
  }
  async getTableData() {
    this.tableLoading = true
    this.tableData = []
    this.params.platform = this.value[0] === 3 ? 3 : 1
    let res = await getChannelList(this.params)
    let dataList = res.data.dataList || []
    dataList.forEach((item: any) => {
      item.icon = item.icon.split('?')[0]
    })
    this.tableData = dataList
    this.tableLoading = false
    this.totalCount = res.data.pageInfo.totalCount
  }
  handleInput(val: string, attr: string) {
    (this.params as any)[attr] = val.replace(/[^0-9]/g, '')
  }
  handleOperate(val: string) {
    let arr = this.selectedData.map((s: any) => s.seq)
    let ids = this.selectedData.map((s: any) => s.id).toString()
    let addrSeq = arr.toString()
    let { nid } = this.params
    switch (val) {
      case 'delete':
        console.log(ids)
        break
      case 'up':
        dragSort({ nid, addr_seq: addrSeq, new_seq: arr[0] - 1 }).then(() => {
          this.getTableData()
        })
        break
      case 'down':
        dragSort({ nid, addr_seq: addrSeq, new_seq: arr[arr.length - 1] + 1 }).then(() => {
          this.getTableData()
        })
        break
      case 'random':
        randomChannels({ nid, addr_seq: addrSeq }).then(() => {
          this.getTableData()
        })
        break
      default:
        break
    }
    this.operate = ''
  }
  handleUpDown(queue: string, operate: 'up'|'down') {
    console.log(queue, operate)
  }
  handleConfig() {
    this.activeIndex = '0'
    this.config = this.platform
    let { nid } = this.params
    let value = ''
    this.getConfig()
    this.$router.push({
      path: '/content/content-channel-index/content-channel',
      query: {
        config: this.config,
        value: value.toString(),
        nid,
        activeIndex: '0'
      }
    })
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    if (!filter) {
      return false
    }
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 260 - filterDom.clientHeight
  }
  async setAppTop(ids: string) {
    let res: any = await setAppTop({
      nid: this.params.nid,
      ids: ids,
      isTop: 1
    })
    if (res.status.code === 0) {
      this['$message'].success('操作成功')
    } else {
      this['$message'].error('操作失败')
    }
    this.getTableData()
  }
  setAppBottom(row: any) {
    let { nid } = this.params
    console.log(row.seq)
    let addrSeq = row.seq
    let newSeq = this.tableData[this.tableData.length - 1]['seq']
    if (addrSeq > newSeq) return false
    dragSort({ nid, addr_seq: addrSeq, new_seq: newSeq }).then((res: any) => {
      this.$message.success('操作成功')
      this.getTableData()
    }).catch((err: any) => {
      console.log(err)
    })
  }
  // 1是排序上升一位, 所以减一, -1下降一位, 相反, 0代表随机
  setAppMove(row: any, seq: -1|0|1) {
    let { nid } = this.params
    let { page, pageCount } = this.params
    let addrSeq = row.seq
    let newSeq = row.seq - seq
    if (seq === 0) {
      const queue = this.tableData.map((item: any) => item.seq).filter((s: number) => s !== addrSeq)
      if (this.tableData.length <= 1) return false
      newSeq = randomOne(queue)
    }
    if (newSeq <= 0) return false
    if (this.totalCount <= page * pageCount) {
      if (newSeq > this.tableData[this.tableData.length - 1]['seq']) {
        return false
      }
    }
    dragSort({ nid, addr_seq: addrSeq, new_seq: newSeq }).then((res: any) => {
      this.$message.success('操作成功')
      this.getTableData()
    }).catch((err: any) => {
      console.log(err)
    })
  }
  setApp(row: any, operate: string) {
    console.log(row, operate)
    switch (operate) {
      case 'top':
        this.setAppTop(row.id)
        break
      case 'bottom':
        this.setAppBottom(row)
        break
      case 'up':
        this.setAppMove(row, 1)
        break
      case 'down':
        this.setAppMove(row, -1)
        break
      case 'random':
        this.setAppMove(row, 0)
        break
      default:
        break
    }
  }
  setAppDelete(ids: string) {
    this.$confirm('确认删除该数据?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let res: any = await setAppDelete({
          nid: this.params.nid,
          ids: ids
        })
        if (res.status.code === 0) {
          this['$message'].success('删除成功')
          this.getTableData()
        } else {
          this['$message'].error('删除失败')
        }
      })
      .catch(() => {})
  }
  // 切换一级分类
  async handleSelectOne(v: number[]) {
    let pid = v[2]
    // 切换一级分类
    await this.getAsideOption(pid, true)
    await this.getTableData()
    this.handleRouteChange()
  }
  handleRouteChange() {
    let { nid } = this.params
    let value = this.value
    this.$router.push({
      path: '/content/content-channel-index/content-channel',
      query: {
        value: value.toString(),
        nid
      }
    })
  }
  // 切换二级分类
  handleSelectSecond(index: string) {
    this.config = ''
    let nid = this.params.nid
    this.params.nid = index
    // this.params.page = 1
    // this.params.pageCount = 20
    this.getTableData()
    // 防止相同路由相同参数报错
    // if (this.params.nid !== nid) {
    //   this.handleRouteChange()
    // }
    this.handleRouteChange()
    this.$nextTick(() => {
      this.setTableHeight()
    })
  }
  handleDateChange1(date: string[]) {
    this.params.updateDateStart = date && date[0]
    this.params.updateDateEnd = date && date[1]
  }
  handleDateChange2(date: string[]) {
    this.params.createDateStart = date && date[0]
    this.params.createDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    console.log(this.params)
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['nid', 'page', 'pageCount'])
    this.params.page = 1
    this.dateArray1 = ['', '']
    this.dateArray2 = ['', '']
    this.getTableData()
  }
  goToAdd(platform: string) {
    this.openWindow({
      name: 'ChannelAddEdit',
      query: {
        platform
      }
    })
  }
  handleSelectionChange(list: IChannel[]) {
    this.selectedData = list
  }
  handleCopy() {
    let copyConfig: number[] = [...this.copyConfig]
    if (copyConfig.length === 5) {
      // eslint 不允许使用下划线命名, 而后端需要的参数是下划线命名, 所以这里这么写
      let srcNid: number = +this.params.nid // 当前渠道 ID
      let dstNid: number = copyConfig[4] // 复制的模板渠道 ID
      console.log({ src_nid: srcNid, dst_nid: dstNid })
      this.$confirm('当前的内容被选中的内容覆盖，不可恢复。请慎重操作。', '确认复制选中的配置吗？', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async() => {
          let res: any = await copyChannel({ src_nid: srcNid, dst_nid: dstNid })
          if (res.status.code === 0) {
            this['$message'].success('操作成功')
            this.copyConfig = []
            this.getTableData()
          } else {
            this['$message'].error('操作失败')
          }
        })
        .catch(() => {})
    } else {
      this.$message.warning('请选择要复制的配置')
    }
    console.log(this.value)
    console.log(this.copyConfig)
  }
  handleSelectAll() {
    // 如果没有选择全部, 则寻找未选择的行, 并将这些行选中
    if (this.selectedData.length < this.tableData.length) {
      let tempSelectList = this.selectedData.map(item => item.id)
      let unSelected: any[] = this.tableData.filter((item: any) => !tempSelectList.includes(item.id))
      unSelected.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleUpdateAll() {
    this['$message'].warning('暂不支持...')
  }
  handleRemoveAll() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    this.setAppDelete(ids)
  }
  async setTopApp(item: IChannel) {
    let ids = item.id.toString()
    await this.setAppTop(ids)
    await this.getTableData()
  }
  updateApp(item: IChannel) {
    console.log(item.id)
    this.routeQuery = {
      id: item.id,
      platform: this.platform,
      nid: this.params.nid
    }
    this.openWindow({
      name: 'ChannelAddEdit',
      query: this.routeQuery
    })
  }
  removeApp(item: IChannel) {
    let ids = item.id.toString()
    this.setAppDelete(ids)
  }
  async handleEdit(i: number, item: IChannel) {
    const { id, seq } = item
    if (typeof seq === 'string' && seq === '') {
      this['$message'].warning('请输入排序!')
      return false
    } else if (seq <= 0) {
      this['$message'].warning('排序不得小于等于0!')
      return false
    }
    let nid = this.params.nid
    let res: any = await setContentSeq({
      nid: Number(nid),
      relateId: id,
      seq: seq
    })
    if (res.status.code === 0) {
      this['$message'].success('操作成功')
      await this.getTableData()
    } else {
      this['$message'].error('操作失败')
    }
  }
  async handleExcel() {
    const filterVal: string[] = [
      'seq',
      'id',
      'name',
      'isShow',
      'startDate',
      'endDate',
      'viewCount',
      'downCount',
      'editor'
    ]
    const theader: string[] = [
      '排序',
      'ID',
      '应用名',
      '是否展示(1:是, -1:否)',
      '开始展示时间',
      '结束展示时间',
      '查看量',
      '下载量',
      '编辑人'
    ]
    if (this.selectedData.length <= 0) {
      return this.$message.warning('请选择数据')
    }
    const list = this.selectedData
    const data = formatJson(filterVal, list)
    exportJson2Excel(theader, data)
    this['$message'].success('导出成功!')
    ;(this.$refs['multiTable'] as any).clearSelection()
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get platform() {
    return (this.value && this.value[0]) === 2 ? 'ios' : 'android'
  }
  rowDrop() {
    const table = document.querySelector('.el-table__body-wrapper tbody')
    const _this = this
    // table 有值时才能对其进行操作
    if (table) {
      Sortable.create(table, {
        handle: '.bars',
        onEnd({ oldIndex, newIndex }: any) {
          if (oldIndex !== newIndex) {
            console.log(oldIndex, newIndex)
            let { nid } = _this.params
            // eslint-disable-next-line camelcase
            let addr_seq = _this.tableData[oldIndex]['seq']
            // eslint-disable-next-line camelcase
            let new_seq = _this.tableData[newIndex]['seq']
            dragSort({ nid, addr_seq, new_seq }).then((res: any) => {
              _this.$message.success('操作成功')
              _this.getTableData()
            }).catch((err: any) => {
              console.log(err)
              // _this.getTableData()
            })
          }
        }
      })
    }
  }

  handleSeq(oldIndex: number, position: number) {
    let newIndex = oldIndex + position
    if (newIndex >= 0) {
      // eslint-disable-next-line camelcase
      let addr_seq = this.tableData[oldIndex]['seq']
      // eslint-disable-next-line camelcase
      let new_seq = this.tableData[newIndex]['seq']
      let { nid } = this.params
      console.log(addr_seq, new_seq)
      dragSort({ addr_seq, new_seq, nid }).then((res: any) => {
        this.$message.success('操作成功')
        this.getTableData()
      })
    }
  }

  handleTopBottom({ seq }: any, position: number) {
    let { page, pageCount, nid } = this.params
    // eslint-disable-next-line camelcase
    let addr_seq = seq
    // eslint-disable-next-line camelcase
    let new_seq = position > 0 ? ((page - 1) * pageCount + 1) : page * pageCount
    console.log({ addr_seq, new_seq, nid })
    dragSort({ addr_seq, new_seq, nid }).then((res: any) => {
      this.$message.success('操作成功')
      this.getTableData()
    })
  }
}
